import React from 'react';
import { useIntl } from 'react-intl';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { SellerFeatures } from '../../../../enums/seller-features';
import { useIsSellerFeatureEnabled } from '../../../../hooks/use-is-seller-feature-enabled';
import messages from '../../messages';
import { AddPurchaseOrderButton } from '../../purchase-orders/add-purchase-order-button';
import { useProductContext } from '../product-context';

/**
 * @module CreatePurchaseOrderWrapper
 * @description A wrapper component for AddPurchaseOrderButton that passes the selected product IDs
 * and product objects from the product context to the AddPurchaseOrderButton component.
 * @param {object} props - Component props
 * @param {number} props.id - The ID of the button
 * @returns {JSX.Element} The AddPurchaseOrderButton with selected product IDs and objects
 */
export const CreatePurchaseOrderButton = (props) => {
  const intl = useIntl();
  const { selectedProductIds } = useProductContext();
  const isInventoryReorderingEnabled = useIsSellerFeatureEnabled(SellerFeatures.InventoryReordering);

  const initializedPurchaseOrder = {
    selectedProductsWithQuantity: selectedProductIds.map((productId) => ({
      productId,
      quantity: 1,
    })),
  };
  const text = intl.formatMessage(messages.createPurchaseOrderButton);
  const isDisabled = selectedProductIds.length === 0 || !isInventoryReorderingEnabled;

  return (
    <AddPurchaseOrderButton
      {...props}
      disabled={isDisabled}
      initializedPurchaseOrder={initializedPurchaseOrder}
      text={text}
      theme={THEME_CONSTANTS.tertiary}
    />
  );
};

export default CreatePurchaseOrderButton;
